export default "__VITE_ASSET__4fa0394a__"